import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { IUser, Role } from '@/models';
import { isTargetRole } from '@/services';

const useShowIncomingCalls = (user: IUser | null) => {
  const { pathname } = useLocation();

  const allowedPathPrefixes = ['/cfs', '/cfs-active'];

  const [showIncomingCalls, setShowIncomingCalls] = useState(false);

  useEffect(() => {
    if (!user) return;

    const isAllowedPage = allowedPathPrefixes.some((prefix) =>
      pathname.startsWith(prefix),
    );
    const shouldShow =
      isAllowedPage &&
      (isTargetRole(user, Role.ACCOUNT_ADMIN) ||
        isTargetRole(user, Role.DISPATCHER));

    setShowIncomingCalls(shouldShow);
  }, [pathname, user]);

  return showIncomingCalls;
};

export default useShowIncomingCalls;
